/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Source_Preview_AriaInputs */



/**
* | output |
* | --- |
* | "Source file preview" |
*
* @param {Marker_Import_Source_Preview_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_source_preview_aria = /** @type {((inputs?: Marker_Import_Source_Preview_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Source_Preview_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu du fichier source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau der Quelldatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima del file sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр исходного файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa del archivo fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源文件预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースファイルのプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत फ़ाइल पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização do arquivo de origem")
	return /** @type {LocalizedString} */ ("Source file preview")
});